import './App.scss';
import { useTheme } from './components/ThemeProvider'
import { Header, Home, Avatar, About, Skill, Experience, Footer } from './components';
import { useRef, useLayoutEffect, useMemo } from 'react'

function App() {

  return (
    <div className="App">
      <Header/>
      <main>
        <Home/>
        <About/>
        <Skill/>
        <Experience/>
        <Footer/>
      </main>
      {/* <svg width="0" height="0">
        <filter id="surface">
          <feTurbulence type="fractalNoise" baseFrequency='.95 .95' numOctaves="80" result='noise' />
          <feDiffuseLighting in='noise' ref={svg} lightingColor='#fff' surfaceScale='.8' result="grind">
            <feDistantLight azimuth='500' elevation='50' />
          </feDiffuseLighting>
          <feGaussianBlur in="grind" stdDeviation=".5"/>
        </filter>
      </svg> */}
    </div>
  );
}

export default App;
